document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById("WarrantyModal");
  var triggers = document.querySelectorAll(".js-warranty-modal-trigger");
  var closeBtn = document.querySelector(".js-warranty-modal-close");

  // If the modal doesn't exist on this page, stop running the script
  if (!modal) return; 

  // TELEPORT MODAL TO BODY: This escapes all parent z-indexes and grid borders!
  document.body.appendChild(modal);

  // Open modal when text is clicked
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      modal.style.display = "block";
    });
  });

  // Close modal when X is clicked
  if(closeBtn) {
    closeBtn.addEventListener('click', function() {
      modal.style.display = "none";
    });
  }

  // Close modal when clicking outside the box
  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  });
});